export const SET_SPEAKER = 'SPEAKER/SET_SPEAKER'
export const SET_SPEAKERS = 'SPEAKER/SET_SPEAKERS'
